import React, {Fragment, useEffect, useState} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Popover, Switch, Divider
} from "antd";

import {DownOutlined, DownloadOutlined, DeleteOutlined, PlusOutlined, InfoCircleOutlined} from '@ant-design/icons';

import ApiService from "../../services/ApiService"
import {MiddleSelect} from "antd/es/pagination/Select";
import IntlMessage from "../util-components/IntlMessage";
import TextArea from "antd/es/input/TextArea";
import {connect, useSelector} from "react-redux";


const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default function OnlyAssoFieldContainer({children,assoc,includeFormats}) {

   const org= useSelector((state) => state.auth.org);

    return (

        <Fragment>
            <Form.Item noStyle shouldUpdate>
                {(form)=>{

                    const assocSelected=assoc || form.getFieldValue("assoc") || "MAIN"
                    const cerfaInfo=org.cerfasInfos?.find(i=>i.id===assocSelected)

                    //console.log("assocSelected",assocSelected)
                    //console.log("cerfaInfo",cerfaInfo)

                    if(!cerfaInfo) {
                        return null
                    }

                    if(includeFormats && !includeFormats.includes(cerfaInfo?._format)){
                        return null
                    }

                    return children;
                }}
            </Form.Item>
        </Fragment>
    )

}
